"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUseIndexedDbFeatureToggle = getUseIndexedDbFeatureToggle;
var _staticApiClientReact = require("@ori/static-api-client-react");
var _constants = require("../constants");
var _logger = require("../logger");
async function getUseIndexedDbFeatureToggle({
  language,
  staticApiUrl,
  tenant
}) {
  (0, _logger.logDebug)('Getting useIndexedDbStorage feature toggle ...');
  let result = false;
  try {
    const staticApiClient = new _staticApiClientReact.ApiClient({
      baseUrl: staticApiUrl,
      language,
      tenant
    });
    const {
      data: {
        isEnabled
      }
    } = await (0, _staticApiClientReact.getTenantFeatureToggle)(staticApiClient, tenant, _constants.USE_INDEXED_DB_FT_GUID);
    (0, _logger.logDebug)('FT value loaded:', isEnabled);
    result = isEnabled;
  } catch (error) {
    _logger.mainLogger.error(error, {
      message: 'Error while loading UseIndexedDb feature toggle.'
    });
  }
  return result;
}